import { takeLatest, call, put } from "redux-saga/effects";
import {
  ENGINEER_EMAIL_ADD_REQUEST,
  engineerEmailAdded,
  engineerEmailAddError,
} from "../../actions/engineers";
import addEmail from "../../../../../backend/oncall/partners/engineers/emails/add";

const requestAddEmail = function*(action) {
  try {
    yield call(addEmail, action.payload.engineerId, action.payload.email);
    yield put(engineerEmailAdded(action.payload.email));
  } catch (error) {
    yield put(engineerEmailAddError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(ENGINEER_EMAIL_ADD_REQUEST, requestAddEmail);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/engineers/request-add-email.js